import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-fm-app-navigation-menu',
  templateUrl: './fm-app-navigation-menu.component.html',
  styleUrls: ['./fm-app-navigation-menu.component.scss'],
})
export class FmAppNavigationMenuComponent implements OnInit {
  @Input() menu: any[];
  public isCollapsed = true;
  public hideMenu = false;

  ngOnInit() {
    this.hideMenu = false;
  }

  public toggleCollapse() {
    this.isCollapsed = false;
  }

  public showTitle(): void {
    this.hideMenu = false;
  }

  public closeListMenu(): void {
    this.isCollapsed = true;
    this.hideMenu = true;
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
